
export const ROOT_PATH: string = "/max"; ///beta
const DOMAIN: string = "http://www.sigma-capital.com";
export const SECURE_DOMAIN: string = "https://www.sigma-cap.com";
const IP_DOMAIN: string = 'http://192.168.100.165';
const DEV_DOMAIN: string = 'https://www.sigma-cap.com'; //http://192.168.162.195 //https://www.sigma-cap.com
const DEV_ALERTS_DOMAIN: string = "https://www.sigma-cap.com" //http://192.168.162.213:8080 //https://www.sigma-cap.com
export const CSS_FLAG: string = "23102023"; //04112021
export const VERSION: string = "0.8.7 Beta (2.0)";
export const LOGIN_PATH = DEV_DOMAIN + "/test/mobileloginform.xml";
export const USER_SEC_PATH = DEV_DOMAIN + "/test/mobileloginform.usersecretword";
//export const SHARES_XML: string = DOMAIN + "/test/get_shares_xml?lang=en";
export const SHARES_XML: string = SECURE_DOMAIN + "/test/get_shares_full_det_xml?lang=en";
export const QUOTES_FIELDS: string = SECURE_DOMAIN + "/test/get_streamer_fields_xml";
export const USER_LAYOUT: string = SECURE_DOMAIN + "/test/get_streamer_cust_param_xml?sessionid=";
export const USER_SETTINGS: string = SECURE_DOMAIN + "/test/get_streamer_cust_param_r_xml";
export const USER_SETTINGS_URL_SAVE: string = SECURE_DOMAIN + "/test/set_streamer_cust_param_react";
export const TRADES_URL: string = SECURE_DOMAIN + "/test/get_market_trades_xml2";
export const CHART_URL: string = SECURE_DOMAIN + "/test/get_chart_hist_xml";
export const NEWS_URL: string = SECURE_DOMAIN + "/test/get_news_xml";
export const USER_UPDATE_SESS: string = SECURE_DOMAIN + "/test/streamer_update_sess?u_sess=";
export const WATCHLIST_URL: string = SECURE_DOMAIN + "/test/get_traded_stocks_xml";
//API_DATA
export const API_GET_SECRET_WORD: string = DEV_DOMAIN + "/sigmaapi/getauth/getlogindata";
export const API_GET_USER_SESSION: string = DEV_DOMAIN + "/sigmaapi/getauth/getusersession";
export const API_GET_USER_META_INFO: string = DEV_DOMAIN + "/sigmaapi/custinfo/getcustinfo";
export const API_SET_USER_LOGOUT: string = DEV_DOMAIN + "/sigmaapi/getauth/logout"
export const API_GET_ACCOUNT_PORTFOLIO: string = DEV_DOMAIN + "/sigmaapi/getportfolio/portfolio";
export const API_GET_ACCOUNT_OTHER_CUSODY_PORTFOLIO: string = DEV_DOMAIN + '/sigmaapi/getportfolio/otherportfolio';
export const API_GET_ACCOUNT_EXTERNAL_MARGIN_BANK_PORTFOLIO: string = DEV_DOMAIN + '/sigmaapi/getportfolio/extmarginbankportfolio';
export const API_GET_INVESTORS_DATA: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/getinvestorsdata";
export const API_GET_INVESTORS_TABLE: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/getinvestorsDistributionTable"
export const API_GET_ACCOUNT_BALANCE: string = DEV_DOMAIN + "/sigmaapi/getaccount/balance";
export const API_GET_ACCOUNT_EXTERNAL_MARGIN_BANK_BALANCE: string = DEV_DOMAIN + "/sigmaapi/getaccount/extmarginbankbuyingpower";
export const API_GET_USER_BUYING_POWER: string = DEV_DOMAIN + "/sigmaapi/getaccount/buyingpower";
export const API_GET_SAV_HISTORY: string = SECURE_DOMAIN + "/main/get_sav_history";
export const API_GET_PIVOT_POINTS: string = SECURE_DOMAIN + "/test/pivot_point_api";
export const API_GET_ACCOUNT_OPEN_ORDERS: string = DEV_DOMAIN + "/sigmaapi/getorder/openorders";
export const API_CHECK_ORDER_DATA: string = DEV_DOMAIN + "/sigmaapi/omsorder/checkdata";
export const API_PLACE_ORDER: string = DEV_DOMAIN + "/sigmaapi/omsorder/placeorder";
export const API_EDIT_ORDER: string = DEV_DOMAIN + "/sigmaapi/omsorder/saveorderedit";
export const API_GET_USER_MOVEMONEY_REQUESTS: string = DEV_DOMAIN + "/sigmaapi/moneyrequest/movemoneyrequestsstatus";
export const API_PREVIEW_USER_MOVEMONEY_REQUEST: string = DEV_DOMAIN + "/sigmaapi/moneyrequest/movemoneyrequestpreview";
export const API_PLACE_USER_MOVEMONEY_REQUEST: string = DEV_DOMAIN + "/sigmaapi/moneyrequest/movemoneyrequestplace";
export const API_CANCEL_USER_MOVEMONEY_REQUEST: string = DEV_DOMAIN + "/sigmaapi/moneyrequest/movemoneyrequestscancel";
export const API_TRANSFER_MOENY_FROM_MARGIN_TO_NORMAL_HISTORY_LIST: string = DEV_DOMAIN + "/sigmaapi/getaccount/mntransferhistory"
export const API_PLACE_TRASNFER_MONEY_FROM_MARGIN_TO_NORMAL: string = DEV_DOMAIN + '/sigmaapi/getaccount/transferefrommton';
export const API_USER_MOVEMONEY_DEPOSIT_REQUEST: string = DEV_DOMAIN + "/sigmaapi/moneyrequest/deposit";
export const API_GET_BANKS_LIST: string = DEV_DOMAIN + "/sigmaapi/moneyrequest/banksdata";
export const API_GET_USER_BANK_DATA: string = DEV_DOMAIN + "/sigmaapi/moneyrequest/userbanksdata";
export const API_GET_ACCOUNT_ACTIVITY: string = DEV_DOMAIN + "/sigmaapi/getaccount/activity";
export const API_GET_TRADE_HISTORY: string = DEV_DOMAIN + "/sigmaapi/getorder/tradehistory";
export const API_GET_ACCOUNT_ORDERS_HISTORY: string = DEV_DOMAIN + "/sigmaapi/getorder/orderhistory";
export const API_GET_TOP_SECTORS: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/sectorranking";
export const API_GET_TOPTEN: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/topten";
export const API_GET_MARKET_DASHBOARD: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/getmarketdashboard";
export const API_GET_SECTOR_PERFORMANCE: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/getMarketSectorsPerformance";
export const API_GET_BLOCK_TRADES: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/getblocktrades";
export const API_UPDATE_USER_DATA: string = DEV_DOMAIN + "/sigmaapi/userdata/updateuserdata";
export const API_GET_BK_LIST: string = DEV_DOMAIN + "/sigmaapi/metadata/custodylist";
export const API_GET_SYMBOL_FULL_DATA: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/symboldata";
export const API_GET_SYMBOL_FULL_BIDSASKS_DATA: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/symbolmarketdepth";
export const API_GET_SYMBOL_TRADES_DATA: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/symboltrades";
export const API_GET_SYMBOL_HISTORY_DATA: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/symbolhistorydata";
export const API_GET_LIVE_TRADED_STOCKS: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/getlivestocks";
export const API_GET_MARKET_BREADTH: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/getmarketbreadth";
export const API_GET_USER_WATCHLIST: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/getwatchlist";
export const API_SAVE_USER_WATCHLIST: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/savewatchlist";
export const API_GET_INVOICE_ORDER_FEES: string = SECURE_DOMAIN + "/test/invoice_fees_for_order";
export const API_RESEARCH_GET_DAILY_TECHNICAL_REPORTS: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/getDailyTechnicalReports?Tech_type=2";
export const API_RESEARCH_GET_TECHNICAL_FOCUS_REPORTS: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/getDailyTechnicalReports";
export const API_RESEARCH_GET_TECHNICAL_SWING_TRADES: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/getDailyTechnicalReports?Tech_type=4";
export const API_RESEARCH_GET_TECHNICAL_TRADING_LEVELS: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/gettradinglevels";
export const API_RESEARCH_GET_FUNDAMENTAL_REPORTS: string = DEV_DOMAIN + "/sigmaapi/getmarketdata/getdailyfoundamentalreports";
export const API_GET_QUOTE_FUNDAMENTAL_INCOME_STATMENT_CHART = DEV_DOMAIN + "/sigmaapi/getmarketdata/fundamentalincomestatement";
export const API_GET_QUOTE_FUNDAMENTAL_BALANCE_SHEET_CHART = DEV_DOMAIN + "/sigmaapi/getmarketdata/fundamentalbalancesheet";
export const API_GET_QUOTE_FUNDAMENTAL_CASH_FLOW_CHART = DEV_DOMAIN + "/sigmaapi/getmarketdata/fundamentalcashflow";
export const API_GET_QUOTE_RESEARCH_REPORTS = DEV_DOMAIN + "/sigmaapi/getmarketdata/getresearchdatasummary";
export const API_WEB_CHART: string = SECURE_DOMAIN + "/webChart/index.html";
export const API_GET_BLUEBAR_LINKS: string = "/bluebarlinks.json";
export const OPEN_ACCOUNT_EN: string = SECURE_DOMAIN + '/main/x_visitor_links.client_account?mobileFlag=true'
export const OPEN_ACCOUNT_AR: string = SECURE_DOMAIN + '/main/x_visitor_links.client_account_ar?mobileFlag=true'
// corporate URL
export const CORPORATE_URL: string = SECURE_DOMAIN + '/corporate/'




//export const API_GET_NEWS: string = DEV_ALERTS_DOMAIN + "/CheckAlertsService/APIMobIntegration?getnews=true&getLastNewsRowsNum=21&";
export const API_GET_NEWS: string = DEV_ALERTS_DOMAIN + "/CheckAlertsService/APIMobIntegration?getnewnews=true&";
export const API_GET_NEWS_DETAILS: string = DEV_ALERTS_DOMAIN + "/CheckAlertsService/APIMobIntegration?getnewsDetails=true&";
export const API_ALERTS_HISTORY: string = DEV_ALERTS_DOMAIN + "/CheckAlertsService/APIMobIntegration";
export const API_ALERTS_CONFIG: string = DEV_ALERTS_DOMAIN + "/CheckAlertsService/APIMobIntegration?loadConfiguration=true&getAlertsTypes=true&";
export const API_CREATE_LOAD_ALERTS_CONFIGURATIONS: string = DEV_ALERTS_DOMAIN + "/CheckAlertsService/APIMobIntegration";
export const API_CREATE_ALERT: string = DEV_ALERTS_DOMAIN + "/CheckAlertsService/AlertServiceServlet";
export const API_ALERTS_UPDATE_READ_FLAG = DEV_ALERTS_DOMAIN + "/CheckAlertsService/APIMobIntegration";
export const API_ALERTS_UPDATE_CONFIGURATION_JSON = DEV_ALERTS_DOMAIN + "/CheckAlertsService/APIJsReqAndResIntegration";
export const API_GET_EVENTS_CALENDAR_DATA: string = DEV_ALERTS_DOMAIN + "/CheckAlertsService/APICalendarIntegration?getCalData=true&";
export const API_GET_QUOTE_INCOME_STATEMENTS: string = DEV_ALERTS_DOMAIN + "/CheckAlertsService/APIMobIntegration?";
export const API_GET_QUOTE_OWNERSHIP_CHART: string = DEV_ALERTS_DOMAIN + "/CheckAlertsService/APIMobIntegration?getOwnershipchart=true&lang=0";
export const API_GET_QUOTE_VALUATION_RATIOS_PERFORMANCE_CHART: string = DEV_ALERTS_DOMAIN + "/CheckAlertsService/APIMobIntegration?getValuationRatiosChart=true&lang=0";
export const API_GET_QUOTE_VALUATION_RATIOS_SUMMARY_CHART: string = DEV_ALERTS_DOMAIN + "/CheckAlertsService/APIMobIntegration?getLatestFinancialData=true&lang=0";
export const API_GET_QUOTE_GROWTH_PROFITABILITY_PERFORMANCE_CHART: string = DEV_ALERTS_DOMAIN + "/CheckAlertsService/APIMobIntegration?getGrowthAndProfitability=true&lang=0";

export const STREAM_SERVER: string = "streamer.sigma-cap.com"; //https://streamer.sigma-cap.com
//http://164.160.104.252 //http://streamer.sigma-capital.com //http://164.160.107.69 //http://192.168.100.121

var qs = require('qs');
let useQuery = () => {
    return qs.parse(window.location.search)
}

export const CONT_STREAM_SERVER = useQuery()['streamserver'] == undefined ? STREAM_SERVER : useQuery()['streamserver'];
export const SECURE_STREAM = useQuery()['secure'] == undefined ? 'true' : useQuery()['secure'];

export const TUTORIAL_VER: string = "4.2.0";
export const TUTORIAL_STEPS_EN = [
    {
        title: 'Welcome',
        intro: "We added new features to our streamer,<br/><b>To learn more , click \"Next\"..</b> "
    },
    {
        title: 'Settings Menu',
        element: "#settingsMenue",
        intro: "Click the <b>menu</b> to open the <b>settings..</b>"
    },
    {
        title: 'Font Size Change',
        element: ".font-size-changer-buttons",
        intro: ". Click <b>(+)</b> to enlarge font size<br/>. Click <b>(-)</b> to reduce font size",
        position: 'left',
        highlightClass: 'fontSCHighlightClass'
    },
    {
        element: ".wms",
        title: "Toggle Search Area",
        intro: "Click here to <b>show/hide search area.</b>"
    },
    {
        title: "Thank you",
        intro: "Thanks for your time, we will announce any new features in the future." +
            "<br/>Click '\"<b>Done</b>'\" to not show this tutorial again"
    }
];
export const TUTORIAL_STEPS_AR = [
    {
        title: 'مرحبا',
        intro: "مرحبا تم اضافة اعدادات جديدة للشاشة اللحظية،<br/> <b>للتعرف عليها اضغط \"التالي\"</b>"
    },
    {
        title: 'قائمة الاعدادات',
        element: "#settingsMenue",
        intro: "اضغط على <b>القائمة لفتح الاعدادات</b>"
    },
    {
        title: 'تغيير حجم الخط',
        element: ".font-size-changer-buttons",
        intro: "اضغط <b>(+)</b> لتكبير حجم الخط  <br/>اضغط <b>(-)</b> لتصغير حجم الخط",
        position: 'right',
        highlightClass: 'fontSCHighlightClass'
    },
    {
        title: 'اعدادات خانة البحث',
        element: ".wms",
        intro: "اضغط هنا <b>لاظهار أو اخفاء</b> خانة البحث"
    },
    {
        title: "شكرا",
        intro: "نشكركم على وقتكم. سوف يتم الاعلان عن أي تطوير جديد في المستقبل." +
            "<br/>اضغط '\"<b>تـم</b>'\" لعدم إظهار هذا المحتوي مجددا"
    }
];

export const QUOTES: string = "Quotes";
export const LEVEL2: string = "Level2";
export const WATCHLIST: string = "Watch List";
export const DETAILED_QUOTE: string = "Detailed Quote";
export const TRADES: string = "Time & Sales";
export const NEWS: string = "News";
export const TOP_TEN: string = "Top Ten";
export const INVESTORS: string = "Investors";
export const CHART: string = "Chart";

export const QUOTES_USERSETTINGS: string = "quotesWindows";
export const WATCHLIST_USERSETTINGS: string = "watchListWindows";
export const LEVEL2_USERSETTINGS: string = "level2Windows";
export const DETAILED_QUOTE_USERSETTINGS: string = "detailedQuoteWindows";
export const TRADES_USERSETTINGS: string = "timeSalesWindows";
export const NEWS_USERSETTINGS: string = "newsWindows";
export const TOP_TEN_USERSETTINGS: string = "topTenWindows";
export const INVESTORS_USERSETTINGS: string = "investorsWindows";
export const CHART_USERSETTINGS: string = "chartWindows";

//window max limit
export const LIMIT_WINDOWS_PROPERTY: boolean = true;
export const MAX_LEVEL2_WINDOWS_NUM: number = 8;
export const MAX_TRADES_WINDOWS_NUM: number = 2;
export const MAX_QUOTES_WINDOWS_NUM: number = 2;
export const MAX_WATCHLIST_WINDOWS_NUM: number = 1;
export const MAX_TOPTEN_WINDOWS_NUM: number = 1;
export const MAX_NEWS_WINDOWS_NUM: number = 1;
export const MAX_RATIOS_WINDOWS_NUM: number = 1;
export const MAX_CHARTS_WINDOWS_NUM: number = 1;
export const MAX_DETAILEDQUOTE_WINDOWS_NUM: number = 4;
export const MAX_DEATAILED_LEVEL2_WINDOW_NUM: number = 1;

export const EGX20_LBL: string = "EGX20";
export const EGX30_LBL: string = "EGX30";
export const EGX30C_LBL: string = "EGX30C";
export const EGX50_LBL: string = "EGX50";
export const EGX70_LBL: string = "EGX70";
export const EGX100_LBL: string = "EGX100";
export const EGXOTC_LBL: string = "OTC";
export const EGXSDT_LBL: string = "SDT";
export const EGXNILE_LBL: string = "EGXNILE";


export const SESSION_STATE_0: String = "Closed";
export const SESSION_STATE_1: String = "Closed";
export const SESSION_STATE_11: String = "Closed";
export const SESSION_STATE_13: String = "Closed";
export const SESSION_STATE_2: String = "Closed";
export const SESSION_STATE_12: String = "Open";
export const SESSION_STATE_15: String = "Open";
export const SESSION_STATE_14: String = "Pre.";
export const SESSION_STATE_19: String = "Adj.";
export const SESSION_STATE_102: String = "Pre.";
export const SESSION_STATE_104: String = "Auc.";
export const SESSION_STATE_105: String = "Open";
export const SESSION_STATE_106: String = "Pre.";

export const SESSION_STATE_AR_0: String = "مغلق";
export const SESSION_STATE_AR_1: String = "مغلق";
export const SESSION_STATE_AR_11: String = "مغلق";
export const SESSION_STATE_AR_13: String = "مغلق";
export const SESSION_STATE_AR_2: String = "مغلق";
export const SESSION_STATE_AR_12: String = "مفتوح";
export const SESSION_STATE_AR_15: String = "مفتوح";
export const SESSION_STATE_AR_14: String = "إستكشاف";
export const SESSION_STATE_AR_19: String = "تعدبل";
export const SESSION_STATE_AR_102: String = "ق.الجلسة";
export const SESSION_STATE_AR_104: String = "مزاد";
export const SESSION_STATE_AR_105: String = "مفتوح";
export const SESSION_STATE_AR_106: String = "ق.الجلسة";

export const STYLE_SESSION_STATE_0: String = "closedStyle";
export const STYLE_SESSION_STATE_1: String = "closedStyle";
export const STYLE_SESSION_STATE_11: String = "closedStyle";
export const STYLE_SESSION_STATE_13: String = "closedStyle";
export const STYLE_SESSION_STATE_2: String = "closedStyle";
export const STYLE_SESSION_STATE_12: String = "openedStyle";
export const STYLE_SESSION_STATE_15: String = "openedStyle";
export const STYLE_SESSION_STATE_14: String = "openedStyle";
export const STYLE_SESSION_STATE_19: String = "openedStyle";
export const STYLE_SESSION_STATE_102: String = "closedStyle";
export const STYLE_SESSION_STATE_104: String = "openedStyle";
export const STYLE_SESSION_STATE_105: String = "openedStyle";
export const STYLE_SESSION_STATE_106: String = "closedStyle";

export const NEW_STYLE_SESSION_STATE_0: String = "var(--error-normal)";
export const NEW_STYLE_SESSION_STATE_1: String = "var(--error-normal)";
export const NEW_STYLE_SESSION_STATE_11: String = "var(--error-normal)";
export const NEW_STYLE_SESSION_STATE_13: String = "var(--error-normal)";
export const NEW_STYLE_SESSION_STATE_2: String = "var(--error-normal)";
export const NEW_STYLE_SESSION_STATE_12: String = "var(--successful-dark)";
export const NEW_STYLE_SESSION_STATE_15: String = "var(--successful-dark)";
export const NEW_STYLE_SESSION_STATE_14: String = "var(--successful-dark)";
export const NEW_STYLE_SESSION_STATE_19: String = "var(--successful-dark)";
export const NEW_STYLE_SESSION_STATE_102: String = "var(--error-normal)";
export const NEW_STYLE_SESSION_STATE_104: String = "var(--successful-dark)";
export const NEW_STYLE_SESSION_STATE_105: String = "var(--successful-dark)";
export const NEW_STYLE_SESSION_STATE_106: String = "var(--error-normal)";


export const QUOTES_FIELDS_LIST = [
    {
        name: "Stock", arName: "الرمز", id: "0", type: "string", colorType: "NONE",
        dataName: "REUTERS", format: "NONE"
    },
    {
        name: "News", arName: "أخبار", id: "1", type: "news", colorType: "NEWS",
        dataName: "NEWS_FLAG", format: "NONE"
    },
    {
        name: "Open", arName: "الفتح", id: "2", type: "number", colorType: "NONE",
        dataName: "PREVIOUS_CLOSE", format: "FLOAT"
    },
    {
        name: "1st", arName: "أول", id: "3", type: "number", colorType: "NONE",
        dataName: "FIRST", format: "FLOAT"
    },
    {
        name: "Last", arName: "السعر", id: "4", type: "number", colorType: "DELTACOLOR",
        dataName: "LAST", format: "FLOAT"
    },
    {
        name: "Ch", arName: "التغير", id: "5", type: "number", colorType: "SIGNCOLOR",
        dataName: "CHANGE", format: "FLOAT"
    },
    {
        name: "Ch%", arName: "%التغير", id: "6", type: "number", colorType: "SIGNCOLOR",
        dataName: "CHANGE_PERCENTAGE", format: "FLOAT"
    },
    {
        name: "VWAP", arName: "م.م", id: "7", type: "number", colorType: "NONE",
        dataName: "CLOSE", format: "FLOAT"
    },
    {
        name: "High", arName: "أعلى", id: "8", type: "number", colorType: "DELTACOLOR",
        dataName: "HIGH", format: "FLOAT"
    },
    {
        name: "Low", arName: "أقل", id: "9", type: "number", colorType: "DELTACOLOR",
        dataName: "LOW", format: "FLOAT"
    },
    {
        name: "Volume", arName: "الحجم", id: "10", type: "number", colorType: "bold",
        dataName: "VOLUME", format: "INTEGER"
    },
    {
        name: "Last Traded", arName: "الوقت", id: "11", type: "string", colorType: "NONE",
        dataName: "LAST_TIME", format: "NONE"
    },
    {
        name: "Turnover", arName: "القيمة", id: "12", type: "number", colorType: "bold",
        dataName: "TURNOVER", format: "INTEGER"
    },
    {
        name: "T.Bids", arName: "اج. طلبات", id: "13", type: "number", colorType: "DELTACOLOR",
        dataName: "TOTAL_BIDS", format: "INTEGER"
    },
    {
        name: "T.Asks", arName: "اج. عروض", id: "14", type: "number", colorType: "DELTACOLOR",
        dataName: "TOTAL_ASKS", format: "INTEGER"
    },
    {
        name: "H. Bid", arName: "أعلى طلب", id: "15", type: "number", colorType: "DELTACOLOR",
        dataName: "HIGH_BID", format: "FLOAT"
    },
    {
        name: "L. Ask", arName: "أقل عرض", id: "16", type: "number", colorType: "DELTACOLOR",
        dataName: "LOW_ASK", format: "FLOAT"
    },
    {
        name: "English Name", arName: "اسم السهم - انجليزي", id: "17", type: "string", colorType: "NONE",
        dataName: "ENG_NAME", format: "NONE"
    },
    {
        name: "Arabic Name", arName: "اسم السهم - عربي", id: "18", type: "string", colorType: "NONE",
        dataName: "ARB_NAME", format: "NONE"
    },
    {
        name: "#Trades", arName: "العمليات", id: "19", type: "number", colorType: "NONE",
        dataName: "TRADES", format: "INTEGER"
    },
    {
        name: "Status", arName: "الحالة", id: "21", type: "state", colorType: "STATE",
        dataName: "STATUS", format: "NONE"
    },
    {
        name: "B/A Spread", arName: "فرق ع/ط", id: "22", type: "number", colorType: "SIGNCOLOR",
        dataName: "BIDASK_SPREAD", format: "FLOAT"
    },
    {
        name: "Ref. Price", arName: "السعر المرجعي", id: "24", type: "number", colorType: "NONE",
        dataName: "REF_PRICE", format: "FLOAT"
    },
    {
        name: "SDT Value", arName: "ذات اليوم - قيمه", id: "25", type: "number", colorType: "DELTACOLOR",
        dataName: "SDT_VALUE", format: "INTEGER"
    },
    {
        name: "SDT%", arName: "ذات اليوم - نسبه", id: "26", type: "number", colorType: "DELTACOLOR",
        dataName: "SDT_PERCENTAGE", format: "FLOAT"
    },
    {
        name: "ISIN", arName: "الكود الدولي", id: "27", type: "string", colorType: "NONE",
        dataName: "ISIN", format: "NONE"
    },
    {
        name: "SDT Limit", arName: "اسهم ذات الجلسة", id: "28", type: "number", colorType: "NONE",
        dataName: "SDT_LIMIT", format: "INTEGER"
    },
    {
        name: "Price Limit", arName: "الحدود السعرية", id: "29", type: "string", colorType: "NONE",
        dataName: "PRICE_LIMIT", format: "NONE"
    },
    {
        name: "Cur.", arName: "العملة", id: "30", type: "string", colorType: "CURRENCY",
        dataName: "CURRENCY", format: "NONE"
    },
    {
        name: "B|S", arName: "ش | ب", id: "31", type: "string", colorType: "BUYSELLICON",
        dataName: "BUYSELLICON", format: "NONE"
    },
    {
        name: "Pre. VWAP", arName: "المتوسط السابق", id: "32", type: "number", colorType: "NONE",
        dataName: "PREVIOUS_VWAP", format: "FLOAT"
    },
    {
        name: "VWAP Ch.", arName: "مقدار المتوسط", id: "33", type: "number", colorType: "SIGNCOLOR",
        dataName: "VWAP_CHANGE", format: "FLOAT"
    },
    {
        name: "VWAP Ch%", arName: "الحدود السعرية", id: "34", type: "number", colorType: "SIGNCOLOR",
        dataName: "VWAP_CHANGE_PERCENTAGE", format: "FLOAT"
    },
    {
        name: "Market Code", arName: "كود السوق", id: "35", type: "string", colorType: "NONE",
        dataName: "marketCode", format: "NONE"
    },
    {
        name: "Type", arName: "تصنيف", id: "36", type: "number", colorType: "NONE",
        dataName: "type", format: "NONE"
    },
    {
        name: "Indices List", arName: "المؤشرات", id: "37", type: "string", colorType: "NONE",
        dataName: "indicesList", format: "NONE"
    },
    {
        name: "Sector", arName: "EN القطاع", id: "38", type: "string", colorType: "NONE",
        dataName: "secEn", format: "NONE"
    },
    {
        name: "Sector Ar.", arName: "القطاع", id: "39", type: "string", colorType: "NONE",
        dataName: "secAr", format: "NONE"
    },
    {
        name: "Day's Range", arName: "نطاق اليوم", id: "40", type: "graph", colorType: "NONE",
        dataName: "dayRange", format: "NONE"
    },
    {
        name: "52 Week Range", arName: "نطاق 52 أسبوع", id: "41", type: "graph", colorType: "NONE",
        dataName: "yearRange", format: "NONE"
    },
    {
        name: "Dir.", arName: "اتجاه", id: "42", type: "graph", colorType: "NONE",
        dataName: "tick", format: "NONE"
    },
    {
        name: "Market Cap", arName: "القيمة السوقية", id: "43", type: "object", colorType: "DELTACOLOR",
        dataName: "market_cap", format: "INTEGER"
    }
    /*,
    {
        name: "", arName: "", id: "", type: "number", colorType: "NONE",
        dataName: "NONE", format: "NONE"
    }*/
];

export const GRID_SMALL_SIZE: number = 60;
export const GRID_MEDIUM_SIZE: number = 110;

export const TRADES_FIELDS_LIST = [
    {
        name: "Stock", arName: "الرمز", id: "0", type: "string", colorType: "NONE",
        dataName: "Symbol", format: "NONE"
    },
    {
        name: "Name", arName: "EN الأسم", id: "1", type: "string", colorType: "NONE",
        dataName: "EngName", format: "NONE"
    },
    {
        name: "Name AR", arName: "الأسم", id: "2", type: "string", colorType: "NONE",
        dataName: "ArbName", format: "NONE"
    },
    {
        name: "Time", arName: "وقت", id: "3", type: "string", colorType: "NONE",
        dataName: "Time", format: "NONE"
    },
    {
        name: "Price", arName: "سعر", id: "4", type: "number", colorType: "NONE",
        dataName: "Price", format: "FLOAT"
    },
    {
        name: "QTY", arName: "كمية", id: "5", type: "number", colorType: "NONE",
        dataName: "Volume", format: "INTEGER"
    },
    {
        name: "VWAP", arName: "م.م", id: "6", type: "number", colorType: "NONE",
        dataName: "VWAP", format: "FLOAT"
    },
    {
        name: "Flag", arName: "مؤشر", id: "7", type: "string", colorType: "NONE",
        dataName: "Indicator", format: "NONE"
    },
    {
        name: "TradeID", arName: "رقم", id: "8", type: "string", colorType: "NONE",
        dataName: "RecCount", format: "NONE"
    },
    {
        name: "Ticket", arName: "رقم", id: "9", type: "string", colorType: "NONE",
        dataName: "Ticket", format: "NONE"
    }
];

export const BIDSASKS_FIELDS_LIST = [
    {
        name: "Bid", arName: "طلب", id: '0', dataName: "PRICE"
    }, {
        name: "Qty", arName: "كمية", id: '1', dataName: "QTY"
    }, {
        name: "#", arName: "#", id: '2', dataName: "COUNT"
    }, {
        name: "Ask", arName: "عرض", id: '3', dataName: "PRICE"
    }, {
        name: "Qty", arName: "كمية", id: '4', dataName: "QTY"
    }, {
        name: "#", arName: "#", id: '5', dataName: "COUNT"
    }, {
        name: "id", arName: "id", id: '6', dataName: "ID"
    }
];

export const TOPTEN_FIELDS_LIST = [{
    name: "SYM", arName: "سهم", id: '0', dataName: "0"
}, {
    name: "Ch.", arName: "التغير", id: '1', dataName: "1"
}, {
    name: "Ch.%", arName: "%التغير", id: '2', dataName: "2"
}, {
    name: "Fluct", arName: "الفرق", id: '3', dataName: "3"
}, {
    name: "Volume", arName: "حجم", id: '4', dataName: "4"
}, {
    name: "High", arName: "أعلى", id: '5', dataName: "5"
}, {
    name: "Low", arName: "أقل", id: '6', dataName: "6"
}, {
    name: "First Price", arName: "سعر الفتح", id: '7', dataName: "7"
}, {
    name: "Close price", arName: "سعر الإغلاق", id: '8', dataName: "8"
}, {
    name: "Price", arName: "السعر", id: '9', dataName: "9"
}, {
    name: "Previous Close", arName: "الإغلاق السابق", id: '10', dataName: "10"
}, {
    name: "Turnover", arName: "قيمة", id: '11', dataName: "11"
}, {
    name: "Code", arName: "رمز", id: '12', dataName: "12"
}, {
    name: "Share Name", arName: "اسم السهم", id: '13', dataName: "13"
}, {
    name: "Share Name AR", arName: "اسم السهم", id: '14', dataName: "14"
    }];
export const STOCK_DETAILS_FIELDS: string = "FIRST,HIGH,LOW,CLOSE,LAST,TOTAL_ASKS,TOTAL_BIDS,HIGH_BID,LOW_ASK,VOLUME,TURNOVER,STATUS,CHANGE,CHANGE_PERCENTAGE,LAST_TIME,BIDASK_SPREAD";

export const QUOTES_MIN_WIDTH: number = 11;
export const QUOTES_MIN_HEIGHT: number = 15;
export const WATCHLIST_MIN_WIDTH: number = 11;
export const WATCHLIST_MIN_HEIGHT: number = 15;
export const LEVEL2_MIN_WIDTH: number = 7;
export const LEVEL2_MIN_HEIGHT: number = 17;
export const TRADES_MIN_WIDTH: number = 13;
export const TRADES_MIN_HEIGHT: number = 15;
export const DETAILED_QUOTE_MIN_WIDTH: number = 13; //13
export const DETAILED_QUOTE_MIN_HEIGHT: number = 40;
export const NEWS_MIN_WIDTH: number = 13;
export const NEWS_MIN_HEIGHT: number = 15;
export const CHART_MIN_WIDTH: number = 11;
export const CHART_MIN_HEIGHT: number = 26;
export const TOP_TEN_MIN_WIDTH: number = 13;
export const TOP_TEN_MIN_HEIGHT: number = 15;
export const INVESTORS_MIN_WIDTH: number = 15; //11//21
export const INVESTORS_MIN_HEIGHT: number = 13; //13//57

export const DEFAULT_DOCUMENT_WIDTH: number = 1240;
export const QUOTES_DEFAULT_WIDTH: number = 23;
export const QUOTES_DEFAULT_HEIGHT: number = 32;
export const WATCHLIST_DEFAULT_WIDTH: number = 20;
export const WATCHLIST_DEFAULT_HEIGHT: number = 32;
export const LEVEL2_DEFAULT_WIDTH: number = 9;
export const LEVEL2_DEFAULT_HEIGHT: number = 32;
export const TRADES_DEFAULT_WIDTH: number = 13;
export const TRADES_DEFAULT_HEIGHT: number = 32;
export const DETAILED_QUOTE_DEFAULT_WIDTH: number = 22; //13
export const DETAILED_QUOTE_DEFAULT_HEIGHT: number = 40;
export const NEWS_DEFAULT_WIDTH: number = 13;
export const NEWS_DEFAULT_HEIGHT: number = 40;
export const CHART_DEFAULT_WIDTH: number = 18;
export const CHART_DEFAULT_HEIGHT: number = 30;
export const TOP_TEN_DEFAULT_WIDTH: number = 18;
export const TOP_TEN_DEFAULT_HEIGHT: number = 25;
export const INVESTORS_DEFAULT_WIDTH: number = 21;
export const INVESTORS_DEFAULT_HEIGHT: number = 57;

export const AGGRIDHEADERHEIGHT: number = 20;
export const AGGRIDROWHIGHT: number = 22;

export const AGGRIDHEADERHEIGHT_SITE: number = 30;
export const AGGRIDROWHIGHT_SITE: number = 30;

export const AGGRIDHEADERHEIGHT_SITE_XL: number = 45;
export const AGGRIDROWHIGHT_SITE_XL: number = 45;

export const AUTO_SAVE_INTERVAL: number = 1800000; // 1800000;



export interface Record { source, item, id };
export interface Table { source, item, connection, tag, status };

export interface GridColumn {
    headerName: string, field: string, suppressSizeToFit: boolean,
    valueParser: any, cellRenderer: string, valueFormatter: any, filter: any,
    filterParams: any, hide: boolean
    //, valueFormatter: any, cellClass: string
};

interface GeneralWindowConfig {
    i: string, x: number, y: number,
    w: number, h: number, t: number
};

export interface XmlElement {
    name: string;
    attributes?: XmlAttributes;
    children?: XmlElement[];
    textNode?: string;
    value: string
}

export interface XmlAttributes {
    prefixedAttributes?: PrefixedXmlAttributes[];
    rawMap?: any;
}
export interface PrefixedXmlAttributes {
    prefix: string;
    map: any;
}

export const enum filterOptions {
    noFilters = 1,
    filters,
    filtersMultiple
}

export const enum ALERT_TYPE {
    success = 'success',
    danger = 'danger',
    warning = 'warning',
    info = 'info',
    light = 'light',
    dark = 'dark',
}

export const RESEARCH_REPORTS_PER_PAGE: number = 10;
export const HISTORICAL_DATA_PER_PAGE: number = 8;
export const NEWS_PER_PAGE: number = 12;
export const EVENTS_PER_PAGE: number = 600;
export const NEWS_SEC_HEIGHT_STYLE: string = 'fit-content' // 70vh
export const NEWS_SEC_MIN_HEIGHT_STYLE: string = '40vh' // 70vh
export const DEFAULT_NEWS_DURATION_FILTERS: number = 30;
export const DEFAULT_EVENTS_DURATION_FILTERS: number = 30;

export const WATCHLIST_DATA = {
    "result": 1,
    "response": {
        "data": {
            "lists": [
                {
                    "id": 0,
                    "label": "Favorites",
                    "stocks": "",
                    "columns": "reuters,buysellicon,last,change,change_percentage,previous_close,high,low,high_bid,low_ask,volume,turnover,market_cap",
                    "columnsWidth": "80,70,55,60,60,60,60,60,60,60,100,100,160"
                }
            ]
        }
    }
}

export const WEBSITE_WATCHLIST_COLUMNS = "reuters,buysellicon,last,change,change_percentage,previous_close,high,low,high_bid,low_ask,volume,turnover,market_cap";
export const WEBSITE_WATCHLIST_COLUMNS_WIDTH = "80,70,55,60,60,60,60,60,60,60,100,100,160";


//export const QuotesWindowConfig: GeneralWindowConfig = { i:"Quotes",}